export default class CustomEvent {
    /** @type {Object<string,(function(params: any):void)[]>} */
    events = {}

    #scope

    /**
     * @param scope
     * @param {Object} [events]
     */
    constructor(scope, events) {
        this.#scope = scope

        Object.keys(events || {}).forEach(name => this.on(name, events[name]))
    }

    /**
     * @param {string} eventName
     * @param {function(any)} cb
     */
    on(eventName, cb) {
        this.events[eventName] = this.events[eventName] || []

        this.events[eventName].push(cb)
    }

    /**
     * @param {string} eventName
     * @param {Object} params
     * @return {*}
     */
    trigger(eventName, params = {}) {
        if (! this.events[eventName]) {
            return
        }

        this.events[eventName].forEach(event => event.call(this.#scope, params))
    }
}
